export default "__VITE_ASSET__BmmbczWD__"